import { Component, inject, OnInit, viewChild } from '@angular/core';
import { CardComponent, CardEmptyComponent } from '@shared/components/card';
import { ProgramTargetFilterComponent } from './components/program-target-filter/program-target-filter.component';
import { ProgramTargetTableComponent } from './components/program-target-table/program-target-table.component';
import { ProgramTargetPaginationComponent } from './components/program-target-pagination/program-target-pagination.component';
import { ProgramTargetService } from './services/program-target.service';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { ModalDetailDistributorComponent } from '@pages/sales-marketing/target-distributor/monitoring/components/modal-detail-distributor/modal-detail-distributor.component';
import { ActivatedRoute } from '@angular/router';
import { ProgramTargetApiService } from './services/program-target-api.service';
import { IProgramTarget, ProgressTypeFilterValues } from './interfaces/tab-program-target.interface';
import { BaseDatasource } from '@shared/base/base.datasource';
import { EnumTargetDistributorStatus } from '@pages/sales-marketing/target-distributor/target-distributor.enum';
import { TargetDistributorService } from '@pages/sales-marketing/target-distributor/target-distributor.service';
import { ModalNilaiInvoiceComponent } from '@pages/sales-marketing/target-distributor/monitoring/components/modal-nilai-invoice/modal-nilai-invoice.component';
import { ModalPotentialPoComponent } from '@pages/sales-marketing/target-distributor/monitoring/components/modal-potential-po/modal-potential-po.component';
import { ModalHadiahLainnyaComponent } from '@pages/sales-marketing/target-distributor/monitoring/components/modal-hadiah-lainnya/modal-hadiah-lainnya.component';

@Component({
  selector: 'app-tab-program-target',
  providers: [ProgramTargetService, ProgramTargetApiService],
  standalone: true,
  imports: [
    CardComponent,
    ProgramTargetFilterComponent,
    ProgramTargetTableComponent,
    ProgramTargetPaginationComponent,
    CardEmptyComponent,
    ModalDetailDistributorComponent,
    ModalNilaiInvoiceComponent,
    ModalPotentialPoComponent,
    ModalHadiahLainnyaComponent,
  ],
  templateUrl: './tab-program-target.component.html',
  styleUrl: './tab-program-target.component.scss',
})
export class TabProgramTargetComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly targetDistributorService = inject(TargetDistributorService);
  readonly service = inject(ProgramTargetService);

  readonly distributorId = this.route.snapshot.paramMap.get('id');
  readonly iconEmptyProgram = STRING_CONSTANTS.ICON.IC_PROMO_NONE;

  private readonly modalDetailProgram = viewChild.required<ModalDetailDistributorComponent>('modalDetailProgram');
  private readonly modalDetailInvoice = viewChild.required<ModalNilaiInvoiceComponent>('modalDetailInvoice');
  private readonly modalOtherRewards = viewChild.required<ModalHadiahLainnyaComponent>('modalOtherRewards');
  private readonly modalPotentialPo = viewChild.required<ModalPotentialPoComponent>('modalPotentialPo');

  selectedProgramTarget: IProgramTarget | null = null;

  ngOnInit() {
    this.service.loadData(this.distributorId!);
  }

  private reload(): void {
    this.service.loadData(this.distributorId!);
  }

  handleSearch(keyword: string): void {
    this.service.setKeyword(keyword);
    this.reload();
  }

  handleApplyFilter(progressType: ProgressTypeFilterValues | undefined): void {
    if (this.service.progressType() === progressType) {
      return;
    }

    this.service.setProgressType(progressType);
    this.reload();
  }

  handlePageChange(event: BaseDatasource<IProgramTarget>): void {
    this.service.dataSource.current_page = event.current_page;
    this.service.dataSource.pageSize = event.pageSize;
    this.reload();
  }

  handleOpenDetailProgram(row: IProgramTarget): void {
    if (row.status_enum === EnumTargetDistributorStatus.SCHEDULED) {
      this.targetDistributorService.routeDetail(row.id);
      return;
    }

    this.selectedProgramTarget = row;
    this.modalDetailProgram().open({
      targetDistributorId: row.id,
      distributorId: this.distributorId!,
      distributorName: row.program_name,
      // [MAI-1296] Halaman ini tidak memuat detail program, tapi endpoint list-nya sudah
      // membedakan: `level` null hanya untuk program satu tingkat (program bertingkat
      // selalu mengirim "Tingkat n", bahkan saat progres masih 0%).
      isSingleLevelProgram: !row.level,
    });
  }

  handleOpenDetailInvoice(): void {
    if (!this.selectedProgramTarget) return;

    this.modalDetailProgram().setHidden(true);
    this.modalDetailInvoice().open({
      targetDistributorId: this.selectedProgramTarget.id,
      distributorId: this.distributorId!,
      distributorName: this.selectedProgramTarget.program_name,
    });
  }
  handleOpenOtherRewards(): void {
    if (!this.selectedProgramTarget) return;

    this.modalDetailProgram().setHidden(true);
    this.modalOtherRewards().open({
      targetDistributorId: this.selectedProgramTarget.id,
      distributorId: this.distributorId!,
    });
  }
  handleOpenPotentialPo(): void {
    if (!this.selectedProgramTarget) return;

    this.modalDetailProgram().setHidden(true);
    this.modalPotentialPo().open({
      targetDistributorId: this.selectedProgramTarget.id,
      distributorId: this.distributorId!,
      distributorName: this.selectedProgramTarget.program_name,
    });
  }
}
